import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './sub-captar.reducer';

export const SubCaptarDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const subCaptarEntity = useAppSelector(state => state.subCaptar.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="subCaptarDetailsHeading">
          <Translate contentKey="crawlerBackendApp.subCaptar.detail.title">SubCaptar</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{subCaptarEntity.id}</dd>
          <dt>
            <span id="subCaptarCode">
              <Translate contentKey="crawlerBackendApp.subCaptar.subCaptarCode">Sub Captar Code</Translate>
            </span>
          </dt>
          <dd>{subCaptarEntity.subCaptarCode}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.subCaptar.gridOperator">Grid Operator</Translate>
          </dt>
          <dd>{subCaptarEntity.gridOperator ? subCaptarEntity.gridOperator.ean : ''}</dd>
        </dl>
        <Button tag={Link} to="/sub-captar" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/sub-captar/${subCaptarEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SubCaptarDetail;
